import React, {useMemo} from 'react';
import Paper from "@material-ui/core/Paper";
import {DataGrid, ruRU} from "@material-ui/data-grid";
import DateTime from "luxon/src/datetime";

const getDevicesTableColumns = (contracts) => [
    {
        field: 'sequenceNumber',
        headerName: '№',
        width: 70,
        sortable: false
    },
    {
        field: 'username',
        headerName: 'Идентификатор',
        minWidth: 180,
        sortable: false
    },
    {
        field: 'date_joined',
        headerName: 'Дата регистрации',
        minWidth: 180,
        sortable: false,
        renderCell: ({value}) => DateTime.fromISO(value).toLocaleString()
    },
    {
        field: 'is_activated',
        headerName: 'Активирован',
        minWidth: 180,
        type: 'boolean',
        editable: true,
        sortable: false
    },
    {
        field: 'contracts',
        headerName: 'Проект',
        flex: 1,
        minWidth: 220,
        type: 'singleSelect',
        valueOptions: contracts,
        renderCell: ({value}) => contracts.find(contract => value.includes(...contract.value))?.label,
        editable: true,
        sortable: false
    },
]

const MobileDevicesTable = (props) => {
    const {devices, contracts, loading, onChange} = props

    const columns = useMemo(() => getDevicesTableColumns(contracts), [contracts])

    return (
        <Paper style={{height: '100%', width: '100%'}}>
            <DataGrid rows={devices?.map((el, index) => ({...el, sequenceNumber: index + 1}))}
                      columns={columns}
                      density={'compact'}
                      localeText={ruRU?.props?.MuiDataGrid?.localeText || ruRU?.components?.MuiDataGrid?.defaultProps?.localeText}
                      disableSelectionOnClick
                      disableColumnMenu
                      loading={loading}
                      onCellEditCommit={onChange}
            />
        </Paper>
    );
};

export default MobileDevicesTable;